import React from 'react'
import { Dialog } from '@headlessui/react'
import { selectFontStyle } from '../../../../../CommonComponent/SelectFontStyle'

export default function PreviewTermsModal({isModalOpen, setIsModalOpen, auctionData}) {
    return (
        <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}
            style={{fontFamily: selectFontStyle(auctionData.font['body_font']), fontWeight: '500'}}
            className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-[#282828cc]"
            id="exampleModalLg"
            tabIndex="-1"
            aria-labelledby="exampleModalLgLabel"
            aria-modal="true"
            role="dialog">
            <Dialog.Panel
                className="pointer-events-none relative flex min-h-[calc(100%-1rem)] mx-5 w-auto
                items-center transition-all duration-300 ease-in-out min-[740px]:mx-auto
                min-[740px]:min-h-[calc(100%-3.5rem)] min-[740px]:max-w-[658px]">
                <div
                    className="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white 
                    bg-clip-padding text-current shadow-lg outline-none">
                    <Dialog.Title
                        className="flex flex-shrink-0 border-b border-[#A1A1A9] items-center justify-between rounded-t-md p-4">
                        <p data-testid="auctionTerms"
                            className="text-[22px] text-[#343434] leading-normal pl-3">Auction Terms and Conditions</p>
                        {/* <!--Close button--> */}
                        <button onClick={() => {setIsModalOpen(false)}}
                            data-testid="close_terms"
                            type="button"
                            className="box-content rounded-none border-none"
                            aria-label="Close">
                            <img src="/images/CloseButton-modalcontent.svg" alt="img" loading="lazy" />
                        </button>
                    </Dialog.Title>
                    {/* <!--Modal body--> */}
                    <div className="relative p-4  sm:mx-8 mx-2.5  mt-2 mb-5">
                        <p id="terms_conditions"
                            className="text-[14px] pr-6 h-[330px] overflow-y-auto overflow-x-hidden customScrollbar
                            text-[#343434] leading-normal"
                            dangerouslySetInnerHTML={{__html: auctionData?.terms_and_condition}}
                        />
                    </div>
                </div>
            </Dialog.Panel>
        </Dialog>
    )
}
